// Brand, navigation and verified contact configuration.

export const SITE = {
  name: "Selling Sunsets",
  tagline: "Property Intelligence & Advisory",
  positioning: "Property Intelligence for Uttarakhand",
  closing: "Understand the place before you buy into it.",
  domain: "sellingsunsets.co.in",
  appDomain: "app.sellingsunsets.co.in",
};

// Verified contact details (provided by owner).
export const CONTACT = {
  whatsapp: "917895232868", // digits only, country code included
  whatsappDisplay: "+91 78952 32868",
  email: "hi@sellingsunsets.co.in",
  founder: "Suhail",
};

// People behind Selling Sunsets.
// Suhail: details corroborated via his public LinkedIn (verified through web
// search citing linkedin.com/in/suhail-abbas-zaidi) and owner-supplied portrait.
// Vibhor: role, education and professional background supplied by owner
// (from his LinkedIn profile); portrait owner-supplied. Public profile URL not
// yet provided — omitted rather than guessed.
export const PEOPLE = [
  {
    key: "suhail",
    name: "Suhail Abbas Zaidi",
    initials: "SA",
    role: "Founder",
    roleConfirmed: true,
    headline: "Founder · Property Intelligence & Advisory",
    location: "Dehradun, Uttarakhand",
    photo: "/images/people/suhail-abbas-zaidi.jpg",
    photoAlt: "Portrait of Suhail Abbas Zaidi, founder of Selling Sunsets, Dehradun",
    linkedin: "https://www.linkedin.com/in/suhail-abbas-zaidi",
    bioStatus: "verified",
    bio: [
      "Suhail Abbas Zaidi is the founder of Selling Sunsets, an independent property-intelligence and buyer-advisory practice for Uttarakhand. Based in Dehradun, he built Selling Sunsets to bring a research-led, buyer-side discipline to a market long shaped by listings and sales narrative rather than genuine understanding of place.",
      "His background spans business development and technology-led ventures — including business development at Shine On and sales and project leadership at Circuit Digital — experience he now channels into building intelligent systems for reading locations, land and property decisions across the state.",
      "At Selling Sunsets his focus is deliberately narrow: help people understand a place — its terrain, regulation, risks and opportunities — before they commit to it. He works directly with buyers seeking an independent perspective on Dehradun, Mussoorie, Rishikesh and the wider Garhwal and Kumaon Himalaya.",
    ],
  },
  {
    key: "vibhor",
    name: "Vibhor Nautiyal",
    initials: "VN",
    role: "Co-founder",
    roleConfirmed: true,
    headline: "Co-founder · Operations & Client Delivery",
    location: "Dehradun, Uttarakhand",
    photo: "/images/people/vibhor-nautiyal.jpg",
    photoAlt: "Portrait of Vibhor Nautiyal, co-founder of Selling Sunsets",
    linkedin: null,
    bioStatus: "verified",
    bio: [
      "Vibhor Nautiyal is co-founder of Selling Sunsets and runs the operational side of the practice — the systems, process and client coordination that turn research into a dependable advisory service. If Selling Sunsets is built on understanding place, Vibhor is responsible for making sure that understanding reaches buyers reliably, on time and in a form they can act on.",
      "His background sits at the intersection of operations and technology. An information-technology graduate of DIT Dehradun with further study in computer and information sciences at Auckland University of Technology, he has worked as a member of technical staff and, since 2020, in operations — across onshore and offshore delivery, procurement, logistics, data warehousing and IT project implementation. Business-process improvement and client relations run through all of it.",
      "At Selling Sunsets that experience translates into how enquiries are handled, how due-diligence work is structured and tracked, and how location intelligence is organised so it can be queried rather than merely read. He works closely with buyers through the practical stages of a decision — the sequencing, the documents, the follow-through — so that the research holds up where it matters most: in execution.",
    ],
  },
];

export const NAV = [
  { label: "Intelligence", to: "/intelligence" },
  { label: "Locations", to: "/locations" },
  { label: "Land & Law", to: "/land-and-law" },
  { label: "Journal", to: "/journal" },
  { label: "Advisory", to: "/advisory" },
  { label: "About", to: "/about" },
];

export function waLink(message) {
  const text = encodeURIComponent(message || "Hi Suhail, I'm considering property in Uttarakhand and would like to discuss.");
  return `https://wa.me/${CONTACT.whatsapp}?text=${text}`;
}

export function mailtoLink(subject, body) {
  const parts = [];
  if (subject) parts.push(`subject=${encodeURIComponent(subject)}`);
  if (body) parts.push(`body=${encodeURIComponent(body)}`);
  return `mailto:${CONTACT.email}${parts.length ? "?" + parts.join("&") : ""}`;
}
